import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { SelectChangeEvent } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { getDetailPagin } from 'src/common/helper';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import InputDatePickerRange from 'src/components/common/field/InputDatePickerRange';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import Pagin, { PaginationType } from 'src/components/common/Pagin';
import { useNotify } from 'src/context/ContextNotify';
import { deleteAPI, getAPI } from 'src/utils/api';
import DialogEditInformation from './dialog/DialogEditInformation';
import DialogIssuanceBarcode from './dialog/DialogIssuanceBarcode';
import DialogRegister from './dialog/DialogRegister';
import DialogScanBarcode from './dialog/DialogScanBarcode';
import DialogScanBarcodeConfirm from './dialog/DialogScanBarcodeConfirm';
import { getToken } from 'src/utils/auth';

const inputStyle = {
  fontSize: '14px',
  height: '32px',
  my: '8px',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '& .MuiInputBase-input': { padding: '5px 14px' },
  '& input::placeholder': {
    fontSize: '14px',
    fontWeight: 500,
    color: '#CCD1D9',
    opacity: 1,
  },
  backgroundColor: 'primary.light',
  flex: 1,
};

type FilterType = {
  patient_name: string;
  patient_number: string;
  status: string;
  start_date: string | null;
  end_date: string | null;
};

const List = () => {
  // const navigate = useNavigate();
  const notifyContext = useNotify();
  const [inventories, setInventories] = useState([]);
  const [checkAPI, setCheckAPI] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [openIssuanceBarcode, setOpenIssuanceBarcode] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openScanBarcode, setOpenScanBarcode] = useState(false);
  const [openScanBarcodeConfirm, setOpenScanBarcodeConfirm] = useState(false);
  const [pagination, setPagination] = useState<PaginationType>();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteBarcode, setDeleteBarcode] = useState('0');
  const [dataRegistered, setDataRegistered] = useState<any>(null);
  const [inventoryUpdate, setInventoryUpdate] = useState<any>(null);
  const [inventoryScanBarcode, setInventoryScanBarcode] = useState<any>(null);

  const [searchs, setSearchs] = useState<FilterType>({
    patient_number: '',
    patient_name: '',
    status: '',
    start_date: '',
    end_date: '',
  });

  const getInventoryList = (page: number) => {
    setCheckAPI(false);
    
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(
      `/inventory?patient_number=${searchs.patient_number}&patient_name=${searchs.patient_name}&status=${searchs.status}&start_date=${searchs.start_date}&end_date=${searchs.end_date}&page=${page}&pagesize=10&token=${token}`
    )
      .then((res) => {
        if (res.code === 200) {
          setInventories(res.data.items);
          setPagination(res.data.pagination);
        }
      })
      .finally(() => {
        setCheckAPI(true);
      });
  };

  useEffect(() => {
    getInventoryList(1);
    // eslint-disable-next-line
  }, []);

  const handleSearch = () => {
    getInventoryList(1);
  };
  const handleCreateNew = () => {
    setOpenRegister(true);
  };
  const handleEditClick = (barcode: string) => {
    
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(
      `/inventory/${barcode}?token=${token}`
    )
      .then((res) => {
        if (res.code === 200) {
          console.log(res);
          setInventoryUpdate(res.data)
          // setInventories(res.data);
          // setPagination(res.data.pagination);
        }
      })
      .finally(() => {
        setCheckAPI(true);
      });
    setOpenEdit(true);
  };

  const handleInputSearch = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setSearchs({
      ...searchs,
      [name]: value,
    });
  };

  const handlePageChange = (eventL: any, value: number) => {
    getInventoryList(value);
  };

  const handleStatusChange = (event: SelectChangeEvent) => {
    setSearchs({
      ...searchs,
      status: event.target.value,
    });
  };

  const handleChangeDateRange = (
    startDate: string | null,
    endDate: string | null
  ) => {
    setSearchs({
      ...searchs,
      start_date: startDate,
      end_date: endDate,
    });
  };

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };
  const handleDeleteClick = (barcode: string) => {
    setOpenConfirm(true);
    setDeleteBarcode(barcode);
  };

  const handleDelete = () => {
    setOpenConfirm(false);
    try {
      const token = getToken();
  
      if (!token) {
        throw new Error('Failed to get access token');
      }
      deleteAPI(`/inventory/${deleteBarcode}?token=${token}`).then((res) => {
        if (res.code === 200) {
          notifyContext.setNotifyMessage({
            show: true,
            message: '削除しました。',
            type: 'success',
          });
          getInventoryList(1);
        }
        if (res.code === 500 || res.code === 501) {
          notifyContext.setNotifyMessage({
            show: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    } catch (error) {
      console.error('Failed to delete data:', error);
      return;
    }
  };

  const handleButtonClick = () => {};

  const handleRegisterConfirm = (data: any) => {
    setDataRegistered(data);
    setOpenRegister(false);
    setOpenIssuanceBarcode(true);
  };

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };

  const handleCloseIssuanceBarcode = () => {
    setOpenIssuanceBarcode(false);
  };

  const handleCloseEditInformation = () => {
    setOpenEdit(false);
  };

  const handleScanBarcode = () => {
    setOpenScanBarcode(true);
  };

  const handleCloseScanBarcode = () => {
    setOpenScanBarcode(false);
  };

  const handleSearchBarcode = (data: any) => {
    setOpenScanBarcode(false)
    setOpenScanBarcodeConfirm(true)
    setInventoryScanBarcode(data)
  };

  const handleScanBarcodeConfirm = () => {
    setOpenScanBarcodeConfirm(false);
  };

  const handleCloseScanBarcodeConfirm = () => {
    setOpenScanBarcodeConfirm(false);
  };

  return (
    <>
      <Stack width={'100%'}>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          spacing={'8px'}
          mb={'30px'}
        >
          <OutlinedInput
            placeholder={'患者ID'}
            sx={inputStyle}
            inputProps={{
              sx: {
                backgroundColor: 'primary.light',
              },
            }}
            name='patient_number'
            value={searchs.patient_number}
            onChange={(event) => handleInputSearch(event)}
          />
          <OutlinedInput
            placeholder={'患者名'}
            sx={inputStyle}
            inputProps={{
              sx: {
                backgroundColor: 'primary.light',
              },
            }}
            name='patient_name'
            value={searchs.patient_name}
            onChange={(event) => handleInputSearch(event)}
          />
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={searchs.status}
            onChange={handleStatusChange}
            sx={{
              backgroundColor: 'primary.light',
              width: '150px',
              '& .MuiInputBase-input.MuiOutlinedInput-input': {
                p: '6px 14px',
              },
            }}
          >
            <MenuItem value={''}>-</MenuItem>
            <MenuItem value={'未使用'}>未使用</MenuItem>
            <MenuItem value={'一部使用'}>一部使用</MenuItem>
          </Select>
          <InputDatePickerRange
            startDate={searchs.start_date}
            endDate={searchs.end_date}
            placeholder='保管期限'
            sxInput={{ height: '32px', width: '240px', fontSize: '14px' }}
            onChange={handleChangeDateRange}
          />

          <BtnGradient text='検索' handleButtonClick={handleSearch} />
          <BtnOutlineGradient
            text='バーコード検索'
            handleButtonClick={handleScanBarcode}
            width='120px'
          />
          <BtnOutlineGradient
            text='在庫登録'
            handleButtonClick={handleCreateNew}
            width='120px'
            srcStartIcon='/images/icons/ic-plus-gradient.svg'
          />
        </Stack>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: 'none',
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              '& .MuiTableCell-root.MuiTableCell-head': {
                borderBottom: '1px solid #F3F3F3',
                fontWeight: 700,
                p: '6px 16px',
                fontSize: '14px',
              },
              '& .MuiTableCell-root.MuiTableCell-body': {
                color: 'primary.dark',
                fontSize: '14px',
                py: '6px',
              },
            }}
            aria-label='simple table'
          >
            <TableHead>
              <TableRow>
                <TableCell>ステータス</TableCell>
                <TableCell>患者ID</TableCell>
                <TableCell>患者名</TableCell>
                <TableCell>製造日</TableCell>
                <TableCell>保管期限</TableCell>
                <TableCell>使用本数</TableCell>
                <TableCell width={'100px'}></TableCell>
                <TableCell width={'100px'}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {checkAPI ? (
                <>
                  {inventories.map((row: any, index) => (
                    <TableRow
                      hover
                      key={index}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        '& .MuiTableCell-root.MuiTableCell-body': {
                          py: '4px',
                          borderBottom: '1px solid #F3F3F3',
                        },
                        cursor: 'pointer',
                      }}
                    >
                      <TableCell>
                        <Button
                          onClick={handleButtonClick}
                          sx={{
                            width: '80px',
                            height: '32px',
                            lineHeight: '14px',
                            fontSize: '12px',
                            fontWeight: '700',
                            color: 'primary.light',
                            p: '6px 11px',
                            background:
                              'linear-gradient(95.64deg, #FC6E51 0%, #FC6E51 100%)',
                            '&:hover': { opacity: 0.8 },
                          }}
                        >
                          {row.status}
                        </Button>
                      </TableCell>
                      <TableCell>{row.patient_number}</TableCell>
                      <TableCell>{row.patient_name}</TableCell>
                      <TableCell>{row.creation_date}</TableCell>
                      <TableCell>{row.expiry_date}</TableCell>
                      <TableCell>{`${row.used_quantity}/${row.total_quantity}`}</TableCell>
                      <TableCell>
                        <BtnOutlineGradient
                          text='変更'
                          handleButtonClick={() => handleEditClick(row.barcode)}
                        />
                      </TableCell>
                      <TableCell>
                        <BtnOutlineGradient
                          text='削除'
                          handleButtonClick={() => handleDeleteClick(row.barcode)}
                          grandient='#DA4453'
                          color='#DA4453'
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  {inventories.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={11}
                        sx={{ textAlign: 'center', verticalAlign: 'center' }}
                      >
                        データがありません
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ) : (
                <>
                  {Array.from(Array(10)).map((_, index) => {
                    return (
                      <TableRow key={index}>
                        {Array.from(Array(8)).map((_, index) => {
                          return (
                            <TableCell key={index}>
                              <Skeleton
                                variant='rounded'
                                width={'100%'}
                                height={30}
                              />
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {inventories.length > 0 && pagination && (
          <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
            <Typography
              component='label'
              sx={{
                color: '#AAB2BD',
                fontWeight: '400',
                fontSize: '10px',
                lineHeight: '12px',
              }}
            >
              {getDetailPagin(pagination)}
            </Typography>
          </Box>
        )}
        {inventories.length > 0 && pagination && pagination.page && (
          <Pagin handlePageChange={handlePageChange} pagination={pagination} />
        )}
      </Stack>
      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />
      <DialogRegister
        open={openRegister}
        handleClose={handleCloseRegister}
        handleConfirm={handleRegisterConfirm}
      />
      <DialogIssuanceBarcode
        open={openIssuanceBarcode}
        handleClose={handleCloseIssuanceBarcode}
        data={dataRegistered}
      />
      <DialogEditInformation
        open={openEdit}
        handleClose={handleCloseEditInformation}
        inventoryUpdate={inventoryUpdate}
      />
      <DialogScanBarcode
        open={openScanBarcode}
        handleClose={handleCloseScanBarcode}
        handleConfirm={handleSearchBarcode}
      />
      <DialogScanBarcodeConfirm
        open={openScanBarcodeConfirm}
        handleClose={handleCloseScanBarcodeConfirm}
        handleConfirm={handleScanBarcodeConfirm}
        inventoryScanBarcode={inventoryScanBarcode}
      />
    </>
  );
};

export default List;
